import React from 'react'

export default function Warehousing() {
  return (
    <div>Warehousing</div>
  )
}
